// =============================================================================
// Global
// =============================================================================

// Primitive Type Helpers
// =============================================================================
export default function () {
    /*Number Helpers*/
    if (!Number.prototype.DivideBy) {
        Number.prototype.DivideBy = function (denom) {
            if (denom !== 0) return this / denom; else return 0;
        };
    }

    if (!Number.prototype.GetPercentage) {
        Number.prototype.GetPercentage = function (denom, decimals) {
            let formatString = '##';
            if (decimals === null || decimals === undefined || decimals < 0) {
                decimals = 1;
            }
            if (decimals > 0) {
                formatString += '.';
            }
            while (decimals > 0) {
                formatString += '0';
                decimals--;
            }

            return kendo.toString(100 * this.DivideBy(denom), formatString) + '%';
        };
    }
    /*String Helpers*/
    if (!String.prototype.RemoveCharacters) {
        String.prototype.RemoveCharacters = function (char) {
            return this.split(char).join('');
        };
    }

    /*Date Helpers*/
    Date.prototype.addMonth = function (month) {
        let newMonth = this.getMonth() + 1 + month;
        let newYear = this.getFullYear();
        if (newMonth > 12) {
            newYear += 1;
        }
        return new Date(`${newMonth}/${this.getDate()}/${newYear}`);
    }

    Date.prototype.addDay = function (day) {
        return new Date(this.getTime() + (day * 24 * 60 * 60 * 1000));
    }

    /*JQuery Add-ons*/
    jQuery.fn.any = function (filter) {
        for (let i = 0; i < this.length; i++) {
            if (filter.call(this[i])) return true;
        }
        return false;
    };

    /*Array Functions*/
    if (!Array.prototype.addElement) {
        Array.prototype.addElement = function (newElement) {
            if (!this.find(function (element) {
                return element.toString() === newElement.toString()
            })) {
                this.push(newElement);
            }
        }
    }
}